import Head from 'next/head';
// import Script from 'next/script';
import { useCookie } from 'next-cookie';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTheme } from '@forma/forma-ui-theme';
import { Button } from '@forma/forma-ui-kit';
import Link from '@/components/Link';
import MetaTags from '@/components/MetaTags';
import PartnershipTable from '@/components/PartnershipTable';
import MarketplaceInfo from '@/components/views/marketplace/MarketplaceInfo';
import MarketplaceCardBuy from '@/components/views/marketplace/MarketplaceCardBuy';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import { getMainDomain } from '@/helpers/getMainDomain';
import useMetaTags from '@/hooks/useMetaTags';
import { PARTNERSHIP_DEBT_PERCENT } from '@/data/constants';

import mockApi from '@/api/mockApi';
import tariffsApi from '@/api/tariffsApi';
import { ITariffItem } from '@/helpers/interfaces/tariffs.interface';

import styles from './marketplace.module.css';

// const enableAnalytics = process.env.ENABLE_ANALYTICS === 'true';
// const dmpCounterId = process.env.DMP_COUNTER_ID;
const lkUrl = process.env.LK_URL;

export const getServerSideProps: GetServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const slug = 'partnership';
  const locale = params!.locale as string;

  try {
    const mainData = await mockApi.getMainData(locale);
    const pageData = await mockApi.getPromoData(locale, `marketplace/${slug}`);
    const tariffsData = await tariffsApi.getTariffs();
    const headersParse = await getHeadersFromServer(req);

    return {
      props: {
        initialState: {
          main: mainData,
        },
        pageData,
        tariffs: tariffsData,
        headersParse,
        ...(await serverSideTranslations(locale, ['common', 'uikit'])),
      },
    };
  } catch (error) {
    return {
      notFound: true,
    }
  }
};

interface PageProps {
  pageData: {
    title: string,
    subtitle: string,
    description: string,
    icon: string,
    videos?: string[],
    images: string[],
    faq: {
      question: string,
      answer: string
    }[],
    cost: string,
  };
  tariffs: ITariffItem[],
}

const Page = ({ pageData, tariffs }: PageProps) => {
  const { t } = useTranslation();
  const cookie = useCookie();

  const metaData = {
    title: `${pageData.title} | ${t('main_company_name')}`,
    description: pageData.subtitle,
    keywords: t('main_keywords'),
  };
  const { lang } = useTheme();
  useMetaTags({ lang, ...metaData });

  const handleClickBuy = (count: number) => {
    const date = new Date();
    cookie.set('ocr', JSON.stringify({
      count
    }), {
      path: '/',
      expires: new Date(date.setDate(date.getDate() + 7)),
      domain: getMainDomain(window.location.hostname)
    });

    location.href = `${lkUrl}/register?lng=${lang}`;
  };

  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>
      <MarketplaceInfo
        {...pageData}
        conditions={
          <>
            <div className={styles.conditionalText}>
              Зарабатывайте <b>{PARTNERSHIP_DEBT_PERCENT}% от суммы каждого платежа</b>, пока привлеченный вами пользователь пользуется сервисом
            </div>
            <PartnershipTable tariffs={tariffs} debtPercent={PARTNERSHIP_DEBT_PERCENT} />
          </>
        }
        prices={
          <MarketplaceCardBuy cost={pageData.cost}>
            <Button
              as={Link}
              viewStyle="primary"
              href="https://datadoc.prmonline.ru/register"
              size="m"
            >
              Стать партнёром
            </Button>
            {/*<ConnectUsModal
              control={
                <Button
                  viewStyle="secondary"
                  size="m"
                >
                  Хочу демо функции
                </Button>
              }
            />*/}
          </MarketplaceCardBuy>
        }
      />
    </>
  );
};

export default Page;
